import * as React from 'react';
import AppBar from '@material-ui/core/AppBar/AppBar';
import { Avatar, Divider, IconButton, MenuItem, Toolbar, Tooltip } from '@material-ui/core';
import Typography from '@material-ui/core/Typography/Typography';
import Sprite, { CostumeEntry } from '../../sprite';
// import CostumeDisplay from '../components/CostumeDisplay';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
// import SettingsGroup from '../components/SettingsGroup';
// import SettingsItem from '../components/SettingsItem';
import LevelManager from '../../levels';
import { WithTranslation, withTranslation } from 'react-i18next';
import { AppRoot, notifyUser } from "../../app";
// import Button from '@material-ui/core/Button';
// import Slider from '@material-ui/core/Slider';
import { translate } from "../../i18n/i18n";
import { Restore } from "../../utils/restore";
import SwapHorizontalCircleIcon from '@material-ui/icons/SwapHorizontalCircle';
import SwapVerticalCircleIcon from '@material-ui/icons/SwapVerticalCircle';
// import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import FlatWorld from "../../world";
// import WorkspaceManager from 'src/workspace';
// import FileCopyIcon from "@material-ui/icons/FileCopy";
import { Explore } from "@material-ui/icons";
import { SpriteEditInfoField } from './components/SpriteEditorInfoField';
// import { SpriteEditorSpriteName } from './components/SpriteEditorSpriteName';
// import TutorialTab from './TutorialTab';
// import Delete from '@material-ui/icons/Delete';
import LocationOn from '@material-ui/icons/LocationOn';
import Input from '../components/Input';
import SpriteList from '../components/SpriteList';
import Gamepad from '../components/Gamepad';
import { hasKeyboardBlocks } from '../../blocks';
import WorkspaceManager from '../../workspace';

export enum SpriteEditorTabs {
    Tutorial = "Tutorial",
    Graphics = "Graphics",
    Costumes = "Costumes",
    Permissions = "Permissions"
}

export class SpriteEditorInstance {
    static INSTANCE: SpriteEditor;
    static SPRITEFIELDS: Array<SpriteEditInfoField> = [];

    static readNewValues() {
        for (let e in this.SPRITEFIELDS) {
            this.SPRITEFIELDS[e].readNewValue(true);
        }
        this.INSTANCE.updateDragging(true);
    }
}

interface SpriteEditorProps extends WithTranslation {
    readonly sprite: Sprite | null;
    readonly onSpriteSelected: (sprite: Sprite | null) => void;
    readonly deleteSprite: (sprite: Sprite) => void;
    readonly setStartConfig: (sprite: Sprite) => void;
    readonly onToggleSpriteMenu: () => void;
    readonly showGamepad: boolean;
    readonly isFullscreen: boolean;
}

interface SpriteEditorState {
    anchorEl: HTMLElement | undefined;
    popoverAnchorEl: HTMLElement | undefined;
    tabsValue: string;
    dragging: boolean;
    spriteName: string | undefined;
    spriteDropdownOpen: boolean;
    isInitialWs: boolean;
    avatarOverflowing: boolean;
}

export class SpriteEditor extends React.Component<SpriteEditorProps, SpriteEditorState> {
    private containerRef = React.createRef<HTMLDivElement>();
    private avatarContainerRef = React.createRef<HTMLDivElement>();
    private resizeObserver: ResizeObserver | null = null;

    constructor(props: SpriteEditorProps) {
        super(props);
        SpriteEditorInstance.INSTANCE = this;
        this.state = {
            anchorEl: undefined,
            popoverAnchorEl: undefined,
            tabsValue: LevelManager.tutorial?.tutorialActive ? SpriteEditorTabs.Tutorial : SpriteEditorTabs.Costumes,
            dragging: false,
            spriteName: props.sprite ? props.sprite.name : undefined,
            spriteDropdownOpen: false,
            isInitialWs: false,
            avatarOverflowing: false
        };
    }

    getIsInitialWs = () => {
        if ((window as any).workspaceManager && (window as any).workspaceManager.activeWorkspace) {
            return (window as any).workspaceManager.initialWorkspaceID === (window as any).workspaceManager.activeWorkspace!.id;
        }
        return false;
    }

    deleteCurrentSprite = () => {
        if (this.props.sprite) {
            this.props.deleteSprite(this.props.sprite);
        }
    };

    setStartConfigCurrentSprite = () => {
        if (this.props.sprite) {
            const { t, sprite } = this.props;
            this.props.setStartConfig(sprite);
            notifyUser(t('SpriteEditor.NOTIFY_START_POSITION_SET'), { variant: 'success' });
        }
    };

    /**
     * Hide input field for costume name and call callback.
     */
    handleNameInputFocusChanged = () => {
        this.setState({
            spriteName: this.props.sprite ? this.props.sprite.name : "Figur",
        });
    };

    /**
     * Update the internal state for the costume as we type it to reduce lag.
     * @param {React.ChangeEvent<HTMLInputElement>} e
     */
    handleSpriteNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ spriteName: e.target.value });
    };

    saveSpriteName = () => {
        if (this.props.sprite && this.state.spriteName) {
            this.props.sprite.name = this.state.spriteName;
        }
    };

    /**
     * Updates the "z-index" of the sprite layer
     */
    handleSpriteLayerChange = (e: any, index: number | number[]) => {
        if (this.props.sprite && typeof index === 'number') {
            this.props.sprite.layer = index;
        }
    };

    /**
     * Opens the "Add costume" menu.
     * @param event
     */
    handleCostumeMenuOpen = (event: any) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    /**
     * Closes the "Add costume" menu.
     */
    handleCostumeMenuClose = () => {
        this.setState({ anchorEl: undefined });
    };

    /**
     * Opens the popup menu.
     * @param event
     */
    handlePopOverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        this.setState({ popoverAnchorEl: event.currentTarget, spriteDropdownOpen: true });
    };

    /**
     * Closes the popup menu.
     */
    handlePopOverClose = () => {
        this.setState({ popoverAnchorEl: undefined, spriteDropdownOpen: false });
    };

    /**
     * Delete a costume from the sprite.
     * @param {CostumeEntry} costume
     */
    handleDeleteCostume = (costume: CostumeEntry) => {
        //Intentionally reusing the same ref for the new state.
        if (this.props.sprite) {
            this.props.sprite.removeCostume(costume);
            this.props.onSpriteSelected(this.props.sprite);
            Restore.createRestorePoint(translate('RestoreMessages.costume.deleted') + costume.name);
            (window as any).renderUtils.generateColorPalette();
        }
    };

    /**
     * Set the sprites costume.
     * @param {CostumeEntry} costume
     */
    handleSetCurrentCostume = (costume: CostumeEntry) => {
        const sprite = this.props.sprite;
        if (sprite && sprite.costumes.indexOf(costume) > -1) {
            sprite.costumeId = costume.id;
            sprite.updateCostume();
            (window as any).renderUtils.generateColorPalette();
        }
    };

    /**
     * Returns the number of the current sprites costumes
     */
    getCostumesLength = () => {
        if (this.props.sprite) {
            return this.props.sprite.costumes.length;
        }
        return 0;
    };
    selectSpriteElement = (sprite: any) => {
        this.updateDragging(true);
        sprite.onClick(this, false);
        this.handlePopOverClose();
        setTimeout(function () {
            SpriteEditorInstance.readNewValues();
        }, 100);
        this.setState({ spriteName: sprite.name, tabsValue: LevelManager.tutorial?.tutorialActive ? SpriteEditorTabs.Tutorial : SpriteEditorTabs.Costumes });
    };

    //check if this works
    createAndOpen = (event: any) => {
        this.createSpriteElements();
        this.handlePopOverOpen(event);
    };

    createSpriteElements = () => {

        let world = (window as any).world as FlatWorld;
        let spriteElements: JSX.Element[] = [];
        const { t } = this.props;

        if (LevelManager.allowNewSprite || LevelManager.isBuildMode()) {
            spriteElements.push(
                <MenuItem
                    key={"spriteEditorDropdown-add-sprite"}
                    onClick={() => {
                        AppRoot.INSTANCE.newSprite();
                        this.setState({ spriteDropdownOpen: false });
                    }}>
                    <Avatar><AddIcon /></Avatar>{["\xa0\xa0", t('MENU.ADD_SPRITE')].join("")}
                </MenuItem>);
            spriteElements.push(<Divider />);
        }

        world.sprites.forEach((sprite) => {
            let index = sprite.costumes.findIndex((c) => c.id === sprite.costumeId);
            // if costume not present, ignore the rest of this function
            if (sprite.costumes[index] === undefined) {
                return;
            }
            if (LevelManager.isBuildMode()) {
                spriteElements.push(
                    <MenuItem
                        key={`spriteEditorDropdown-${sprite.id}-${sprite.costumeId}`}
                        onClick={() => this.selectSpriteElement(sprite)}>
                        <Avatar alt={sprite.name.charAt(0)} src={sprite.costumes[index].image.src} />
                        {["\xa0\xa0", sprite.name].join("")}
                    </MenuItem>);
            } else {
                if (sprite.programmable) {
                    spriteElements.push(
                        <MenuItem
                            key={`spriteEditorDropdown-${sprite.id}-${sprite.costumeId}`}
                            onClick={() => this.selectSpriteElement(sprite)}>
                            <Avatar alt={sprite.name.charAt(0)} src={sprite.costumes[index].image.src} />
                            {["\xa0\xa0", sprite.name].join("")}
                        </MenuItem>);
                }
            }
        });
    };

    handleTabChange = (event: any, value: string) => {
        this.setState({ tabsValue: value });
    };

    handleToggleSystemCostume = (costume: CostumeEntry) => {
        costume.isSystemCostume = !costume.isSystemCostume;
    };

    // keep track of latest dragging update
    private latest: any = {
        x: 0,
        y: 0,
        dragging: false,
        update: Date.now(),
    };
    updateDragging = (force: boolean = false) => {
        // is last update more than 100ms ago?
        if (Date.now() - this.latest.update < 100 && !force) {
            return;
        }
        // check if not playing, sprite is set, and there are any changes
        if ((!AppRoot.INSTANCE.state.isPlaying && this.props.sprite
            && (
                this.props.sprite.x !== this.latest.x
                || this.props.sprite.y !== this.latest.y
                || this.props.sprite.dragging !== this.latest.dragging
            ))
            || (force && this.props.sprite)
        ) {
            // update interface
            this.setState({ dragging: this.props.sprite.dragging });
            // update latest status
            this.latest.x = this.props.sprite.x;
            this.latest.y = this.props.sprite.y;
            this.latest.dragging = this.props.sprite.dragging;
            this.latest.update = Date.now();
        }
    };

    onMouseMovePixi(spriteEditor: SpriteEditor) {
        // create event trigger callback
        return () => {
            if (spriteEditor.props && spriteEditor.props.sprite && spriteEditor.props.sprite.dragging) {
                spriteEditor.updateDragging();
            }
        };
    }

    componentDidMount() {
        // set event listener
        let pixieAppContainer = document.querySelector('#pixi-app-container > canvas') as HTMLElement;
        if (pixieAppContainer) {
            pixieAppContainer.onmousemove = this.onMouseMovePixi(this);
            pixieAppContainer.onmousedown = () => {
                this.setState({ dragging: true });
            };
            pixieAppContainer.onmouseup = () => {
                SpriteEditorInstance.readNewValues();
                this.setState({ dragging: false });
            };
        }
        
        // Setup ResizeObserver to detect container size changes
        if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(this.checkAvatarOverflow);
            
            if (this.containerRef.current) {
                this.resizeObserver.observe(this.containerRef.current);
            }
        }
        
        // Initial check
        this.checkAvatarOverflow();
        
        // Also listen for window resize events as fallback
        window.addEventListener('resize', this.checkAvatarOverflow);
        
        // Delay the initial overflow check to ensure the component is fully rendered
        setTimeout(this.checkAvatarOverflow, 200);
    }

    componentDidUpdate(prevProps: Readonly<SpriteEditorProps>, prevState: Readonly<SpriteEditorState>) {
        if (this.props.sprite !== prevProps.sprite && this.props.sprite) {
            this.setState({ spriteName: this.props.sprite.name });
            
            // Check for overflow after sprite change
            setTimeout(this.checkAvatarOverflow, 0);
        }
        
        // If the ResizeObserver isn't observing the container yet (e.g., it wasn't mounted during componentDidMount),
        // observe it now
        if (this.resizeObserver && this.containerRef.current && !prevState.avatarOverflowing && this.state.avatarOverflowing) {
            this.resizeObserver.observe(this.containerRef.current);
        }
    }

    componentWillUnmount() {
        // reset event listener
        let pixieAppContainer = document.querySelector('#pixi-app-container > canvas') as HTMLElement;
        if (pixieAppContainer) {
            pixieAppContainer.onmousemove = pixieAppContainer.onmousedown = pixieAppContainer.onmouseup = null;
        }
        
        // Clean up ResizeObserver
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
        
        // Remove window resize listener
        window.removeEventListener('resize', this.checkAvatarOverflow);
    }

    // Check if avatar is overflowing its container
    checkAvatarOverflow = () => {
        // Default to showing avatar for wider screens
        if (window.innerWidth > 1000) {
            if (this.state.avatarOverflowing) {
                this.setState({ avatarOverflowing: false });
            }
            return;
        }

        if (this.containerRef.current && this.avatarContainerRef.current) {
            const containerRect = this.containerRef.current.getBoundingClientRect();
            
            // Simpler overflow check - just see if we have at least 400px available in the container
            const containerWidth = containerRect.width;
            const isOverflowing = containerWidth < 400;
            
            if (isOverflowing !== this.state.avatarOverflowing) {
                this.setState({ avatarOverflowing: isOverflowing });
            }
        } else {
            // If refs aren't available yet, default to not overflowing
            if (this.state.avatarOverflowing) {
                this.setState({ avatarOverflowing: false });
            }
        }
    };

    // Check if any workspace has keyboard blocks
    hasKeyboardBlocksInToolbox = (): boolean => {
        const workspaceManager = (window as any).workspaceManager as WorkspaceManager;
        if (workspaceManager) {
            // Check all workspaces, not just the active one
            for (const workspace of workspaceManager.workspaces) {
                if (workspace && workspace.toolbox) {
                    const blocks = workspace.toolbox.getActiveBlocks();
                    if (hasKeyboardBlocks(blocks)) {
                        return true;
                    }
                }
            }
        }
        return false;
    };

    render() {
        const { isInitialWs } = this.state;
        let { tabsValue } = this.state;
        const { t, sprite } = this.props;

        if (this.getIsInitialWs() !== isInitialWs) {
            this.setState({ isInitialWs: this.getIsInitialWs() });
        }

        if (!sprite) {
            return (
                <div>
                    <AppBar position="static" color="default">
                        <Toolbar>
                            <Typography variant="h6" color="inherit">{t('SpriteEditor.NoSpriteSelected')}</Typography>
                        </Toolbar>
                    </AppBar>
                </div>);
        }

        if (AppRoot.INSTANCE.state.isPlaying && AppRoot.INSTANCE.state.isLoading) {
            this.createSpriteElements();
        }

        // You can't adjust the rendering on a static background
        if (tabsValue === SpriteEditorTabs.Graphics && sprite.isStaticBackground) {
            tabsValue = SpriteEditorTabs.Costumes;
        }

        let isBackground: boolean = sprite.isStaticBackground;
        let positionNotEditable = AppRoot.INSTANCE.state.isPlaying || this.state.dragging;
        let index = sprite.costumes.findIndex((c) => c.id === sprite.costumeId);
        let spriteCurrentCostumeImage = null;
        if (index >= 0) {
            spriteCurrentCostumeImage = sprite.costumes[index].image.src;
        }

        // Determine whether to show gamepad based on both the props and keyboard blocks presence across any sprite
        const shouldShowGamepad = this.props.showGamepad && this.hasKeyboardBlocksInToolbox();

        return (
            <>
                {
                !this.props.isFullscreen &&
                <div 
                    ref={this.containerRef}
                    style={{ backgroundColor: '#40A356', borderRadius: "8px", border: "4px solid rgb(38, 77, 46)" }}
                >
                    <Toolbar style={{ padding: "0px", margin: 0 }}>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%"}}>
                            <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                                <div 
                                    ref={this.avatarContainerRef}
                                    style={{
                                        position: 'relative',
                                        width: this.state.avatarOverflowing ? 'auto' : '30%', 
                                        minWidth: this.state.avatarOverflowing ? '42px' : '30%',
                                        flexShrink: 0,
                                        userSelect: 'none', 
                                        display: 'flex',
                                        justifyContent: this.state.avatarOverflowing ? 'flex-start' : 'center', 
                                        alignItems: 'center',
                                        flexDirection: 'row',
                                        marginLeft: this.state.avatarOverflowing ? '10px' : '10px', 
                                        marginRight: this.state.avatarOverflowing ? '10px' : '0',
                                        zIndex: 2
                                    }}
                                >
                                    {/* Avatar - conditionally visible */}
                                    {!this.state.avatarOverflowing && (
                                        <div style={{ 
                                            position: 'absolute',
                                            display: 'flex', 
                                            alignItems: 'center',  
                                            justifyContent: 'center',
                                            zIndex: 2, 
                                            cursor: 'pointer',
                                            left: '15px', 
                                        }}>
                                            <Avatar
                                            onClick={() => this.props.onToggleSpriteMenu()}
                                            style={{ width: "80px", height: "80px" }}
                                            src={spriteCurrentCostumeImage || ''}
                                            imgProps={{ style: { objectFit: 'contain', width: '100%', height: '100%' } }}
                                            />
                                        </div>
                                    )}
                                    <div style={{ 
                                        position: this.state.avatarOverflowing ? 'relative' : 'absolute', 
                                        display: 'flex', 
                                        alignItems: 'center',  
                                        justifyContent: 'center',
                                        top: this.state.avatarOverflowing ? 0 : -40, 
                                        left: this.state.avatarOverflowing ? 0 : 75,
                                        zIndex: 3
                                    }}>
                                        <IconButton 
                                            style={{ 
                                                backgroundColor: '#1A652B', 
                                                border: '2px solid rgb(22, 61, 31)', 
                                                cursor: 'pointer', 
                                                width: "42px", 
                                                height: "42px" 
                                            }} 
                                            onClick={() => this.props.onToggleSpriteMenu()} 
                                        >
                                            <EditIcon style={{ color: 'white', width: "20px", height: "20px" }} />
                                        </IconButton>
                                    </div>
                                </div>
                                
                                {/* Rest of the UI */}
                                <div style={{ 
                                    display: "flex", 
                                    flexWrap: "wrap", 
                                    justifyContent: "center", 
                                    alignItems: "center", 
                                    flexGrow: 1,
                                    width: this.state.avatarOverflowing ? "auto" : "60%", 
                                    padding: 1, 
                                    flexDirection: "column", 
                                    paddingLeft: this.state.avatarOverflowing ? "10px" : "15px",
                                    paddingRight: "8px", 
                                    paddingTop: "8px", 
                                    paddingBottom: "8px", 
                                    gap: "4px" 
                                }}>
                                    <div style={{display: "flex", alignItems: "center", width: "100%", gap: "12px" }}>
                                        <div style={{ maxWidth: "130px", alignItems: "flex-start", flexGrow: this.state.avatarOverflowing ? 1 : 0 }}>
                                            <Input 
                                                value={this.state.spriteName} 
                                                onChange={this.handleSpriteNameChange}
                                                onBlur={this.saveSpriteName}
                                                style={{ padding: '8px', width: "100%" }}
                                            />
                                        </div>

                                        {
                                            (sprite.draggable || LevelManager.isBuildMode()) && !isBackground &&
                                            <Tooltip title={t('SpriteEditor.TooltipSetStartConfig').toString()}>
                                                <IconButton
                                                style={{ backgroundColor: '#1A652B', border: '3px solid rgb(22, 61, 31)', cursor: 'pointer', width: "42px", height: "42px" }}
                                                disabled={positionNotEditable}
                                                onClick={this.setStartConfigCurrentSprite}>
                                                        <LocationOn style={{color: "#fff"}}/>
                                                    </IconButton>
                                            </Tooltip>
                                        }
                                    </div>
                                    <div style={{ flexGrow: 1 }} />
                                    <div style={{display: "flex",  flexWrap: 'wrap', justifyContent: "flex-start", alignItems: "center", width: "100%", gap: "10px" }}>
                                        <SpriteEditInfoField sprite={sprite} spriteInfo={"x"}
                                            icon={<SwapHorizontalCircleIcon style={{ color: 'rgb(22, 61, 31)'}} />}
                                            disabled={positionNotEditable}
                                            updateDragging={this.updateDragging}
                                            width={15}/>
                                        <SpriteEditInfoField sprite={sprite} spriteInfo={"y"}
                                            icon={<SwapVerticalCircleIcon style={{ color: 'rgb(22, 61, 31)'  }} />}
                                            disabled={positionNotEditable}
                                            updateDragging={this.updateDragging}
                                            width={15} />
                                        <SpriteEditInfoField sprite={sprite} spriteInfo={"rotation"}
                                            icon={<Explore style={{ color: 'rgb(22, 61, 31)' }} />}
                                            disabled={positionNotEditable}
                                            updateDragging={this.updateDragging}
                                            width={15} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Toolbar>
                </div>
                }

                {
                    !(shouldShowGamepad || this.props.isFullscreen) &&
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        border: "4px solid #584915",
                        borderRadius: "8px",
                        backgroundColor: "#ECCF6B",
                        padding: "0.5rem",
                        flexGrow: 1,
                        gap: "8px",
                        minHeight: 'fit-content',
                        flexWrap: "wrap"
                    }}>
                        <div style={{ display: 'flex',  justifyContent: 'space-between', alignItems: 'center', width: '100%',  }}>
                            <div style={{ flex: "1 1 auto", minWidth: "100px" }}>
                                <SpriteList selectSpriteElement={this.selectSpriteElement} activeSpriteId={this.state.spriteName} />
                            </div>
                            {(LevelManager.allowNewSprite || LevelManager.isBuildMode()) && (
                                <IconButton
                                    style={{
                                        backgroundColor: '#FAA31E',
                                        border: '3px solid #373737',
                                        cursor: 'pointer',
                                        width: "60px",
                                        height: "60px",
                                        flexShrink: 0,
                                        marginLeft: "10px",
                                    
                                    }}
                                    onClick={() => {
                                        AppRoot.INSTANCE.newSprite();
                                    }}
                                >
                                    <AddIcon style={{ color: 'white', width: "40px", height: "40px" }} />
                                </IconButton>
                            )}
                        </div>
                    </div>}
                {
                    (shouldShowGamepad || this.props.isFullscreen ) &&
                    <Gamepad />
                }
            </>

        );
    }
}

export default withTranslation()(SpriteEditor);
